import * as React from "react";
import { TransformGroup } from "./TransformGroup";

const LikeIcon = ({ fill }: { fill?: string } = {}) => (
    <path
        d="M6.33404 14.2949L3.63143 14.7127C3.29528 14.7694 2.94789 14.6551 2.75395 14.3748C2.22684 13.6128 1.62402 12.2577 2.05937 10.5221C2.14718 10.172 2.45234 9.92745 2.80855 9.86937L4.25101 9.62236M6.33404 14.2949C5.11226 13.7617 4.193 12.8874 3.97494 11.6674C3.59986 9.56896 5.40217 7.90598 6.12595 7.13795C6.84972 6.36993 6.79282 3.91279 8.21844 4.02346C9.45597 4.11953 9.45811 6.02468 9.2998 7.07578C9.68761 7.03991 10.8044 7.09413 12.1691 7.59792C13.5338 8.10172 13.2417 8.99529 12.9251 9.37911C13.5675 10.2221 13.1187 10.9274 12.814 11.1746C13.6296 11.8865 13.1146 12.6611 12.7551 12.9594C13.3609 14.6016 10.7008 14.9495 9.295 14.9182C8.25039 14.8861 7.21379 14.6789 6.33404 14.2949Z"
        stroke="currentColor"
        fill={fill || "none"}
        transform="translate(0, -1)"
    />
);

const DislikeIcon = ({ fill }: { fill?: string } = {}) => (
    <TransformGroup rotation="reverse">
        <LikeIcon fill={fill} />
    </TransformGroup>
);

const fillColor = "#C1C1C1";

export const Like = {
    Empty: LikeIcon,
    Filled: () => <LikeIcon fill={fillColor} />,
};

export const Dislike = {
    Empty: DislikeIcon,
    Filled: () => <DislikeIcon fill={fillColor} />,
};
